<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-6">
    </base-header>

    <div class="container-fluid mt--7">
      <form role="form" v-on:submit="search">
        <div class="search row">
          <div class="dropdown"></div>
          <div class="col-lg-4 pt-0 pl-0 pr-2">
            <base-input
              alternative=""
              label=""
              placeholder="ข้อมูลที่ต้องการค้นหา"
              input-classes="form-control-alternative"
              v-model="keyword"
            />
          </div>
          <input
            type="submit"
            class="btn btn-primary mt--2 mt-md-0 mb-md-4"
            value="ค้นหาข้อมูล"
          />
        </div>
      </form>
      <div class="row">
        <div class="col">
          <log-table
            title="ประวัติการแก้ไข"
            :logs.sync="logs"
            :total.sync="paginate.total"
            :page.sync="paginate.page"
            ref="logs_table"
          ></log-table>
          <base-pagination
            :total="paginate.total"
            :perPage="paginate.perPage"
            class="mt-2 d-flex justify-content-end"
            v-model="paginate.page"
          ></base-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LogTable from "./Tables/LogTable";
import kickMixin from "../mixins/kickMixin";

export default {
  name: "log",
  mixins: [kickMixin],
  components: {
    LogTable,
  },
  data() {
    return {
      keyword: "",
      logs: [],
      paginate: {
        total: 0,
        page: 1,
        perPage: 30,
      },
    };
  },
  methods: {
    // loadLogs: function() {
    //   var localApp = this;
    //   axios
    //     .get("/api/log?page=" + localApp.paginate.page, {
    //       headers: {
    //         Authorization: "Bearer " + localStorage.token,
    //       },
    //     })
    //     .then(function(response) {
    //       localApp.logs = response.data.data.data;
    //       localApp.paginate.total = response.data.data.total;
    //     })
    //     .catch(function() {
    //       localApp.kick();
    //     });
    // },
    search: async function(e) {
      e.preventDefault();
      this.$refs.logs_table.search(this.keyword);
    },
  },
  // watch: {
  //   "paginate.page": function() {
  //     this.loadLogs();
  //   },
  // },
  created: function() {
    if (!localStorage.token) {
      this.kick();
    } else {
      // this.loadLogs();
    }
  },
};
</script>
<style>
.search {
  margin: 0 auto;
  display: flex;
  justify-content: center;
}
a {
  cursor: pointer;
}
.form-control,
.btn {
  font-size: 1rem;
}
</style>
